/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ReportOwner model module.
 * @module model/ReportOwner
 * @version 0.0.1
 */
class ReportOwner {
    /**
     * Constructs a new <code>ReportOwner</code>.
     * @alias module:model/ReportOwner
     */
    constructor() { 
        
        ReportOwner.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ReportOwner</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ReportOwner} obj Optional instance to populate.
     * @return {module:model/ReportOwner} The populated <code>ReportOwner</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReportOwner();

            if (data.hasOwnProperty('longid')) {
                obj['longid'] = ApiClient.convertToType(data['longid'], 'String');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ReportOwner</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReportOwner</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['longid'] && !(typeof data['longid'] === 'string' || data['longid'] instanceof String)) {
            throw new Error("Expected the field `longid` to be a primitive type in the JSON string but got " + data['longid']);
        }
        // ensure the json data is a string
        if (data['label'] && !(typeof data['label'] === 'string' || data['label'] instanceof String)) {
            throw new Error("Expected the field `label` to be a primitive type in the JSON string but got " + data['label']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {String} longid
 */
ReportOwner.prototype['longid'] = undefined;

/**
 * @member {String} label
 */
ReportOwner.prototype['label'] = undefined;

/**
 * @member {String} email
 */
ReportOwner.prototype['email'] = undefined;






export default ReportOwner;

